import { MenuItem, Select } from "@mui/material";
import styles from "./ItemListToolbar.module.css";

// Top bar above the grid: count + page-size + sort dropdowns. The sort
// options are translated into NetSuite-friendly keys by the caller.
export const SORT_OPTIONS = [
  { value: "relevance", label: "Relevance" },
  { value: "price_asc", label: "Price: Low to High" },
  { value: "price_desc", label: "Price: High to Low" },
  { value: "name_asc", label: "Name: A–Z" },
  { value: "newest", label: "Newest" },
];

export const PAGE_SIZES = [12, 24, 48, 96];

export default function ItemListToolbar({ count, pageSize, onPageSize, sort, onSort }) {
  return (
    <div className={styles.bar}>
      <div className={styles.count}>{count} {count === 1 ? "Product" : "Products"}</div>
      <div className={styles.controls}>
        <Select
          size="small"
          value={pageSize}
          onChange={(e) => onPageSize?.(Number(e.target.value))}
          variant="standard"
          disableUnderline
          className={styles.select}
        >
          {PAGE_SIZES.map((n) => <MenuItem key={n} value={n}>{n} per page</MenuItem>)}
        </Select>
        <Select
          size="small"
          value={sort}
          onChange={(e) => onSort?.(e.target.value)}
          variant="standard"
          disableUnderline
          className={styles.select}
        >
          {SORT_OPTIONS.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
        </Select>
      </div>
    </div>
  );
}
